import React, { useEffect, useState } from 'react';
import { ButtonQuaternary, SpacerVertical, SpacerHorizontal } from '@klarna/bubble-ui';
import { HorizontalWrapper } from 'moet-core';
import { CallToActionButton, SecondaryButton, ToggleWrappedContent } from '@/components';
import { OnboardingFieldSetComponent } from '@/bpc/components/OnboardingFieldComponent/OnboardingFieldSetComponent';
const tPrefix = 'products-fe.general.buttons';
export const StakeholderSubGroupComponent = ({ canGoBack = false, canSkipRole = false, forceUpdate = () => undefined, group, isLoading = false, max = Number.MAX_SAFE_INTEGER, min = 0, onBack = () => undefined, onNext = () => undefined, role, stakeholderItems = [], t, }) => {
    const [yesNo, setYesNo] = useState(stakeholderItems.length || !canSkipRole ? true : undefined);
    useEffect(() => {
        if (yesNo && stakeholderItems.length < min) {
            addItems(min - stakeholderItems.length);
        }
    }, []);
    const addItems = (number = 1) => {
        Array(number)
            .fill(null)
            .forEach(() => {
            const addedFieldSet = group.addItem();
            const field = addedFieldSet.find(f => f.absolutePath.endsWith('person_role'));
            group.setValueOfField(field, [role]);
        });
        forceUpdate();
    };
    const onAddItem = (event) => {
        // eslint-disable-next-line no-unused-expressions
        event === null || event === void 0 ? void 0 : event.preventDefault();
        addItems(1);
    };
    const onDeleteItem = (index) => {
        group.deleteItem(index);
        forceUpdate();
    };
    const removeStakeholdersWithRole = (role) => {
        group.fields.forEach((fields, index) => {
            const roleField = fields.find(f => f.absolutePath.endsWith('person_role'));
            const value = group.getValueForField(roleField.absolutePath);
            if (!value) {
                return;
            }
            if (value.includes(role) && value.length === 1) {
                onDeleteItem(index);
            }
            else {
                group.setValueOfField(roleField, value.filter(v => v !== role));
            }
        });
        forceUpdate();
    };
    const onBlurOfField = (field) => (value) => {
        group.setValueOfField(field, value);
        // to recalculate whether to disable Next button // TODO is this really needed?
        forceUpdate();
    };
    const onToggle = (toggleValue) => {
        if (yesNo && !toggleValue) {
            removeStakeholdersWithRole(role);
        }
        else if (!yesNo && toggleValue) {
            addItems(min);
        }
        setYesNo(toggleValue);
    };
    const Content = () => (React.createElement(React.Fragment, null,
        stakeholderItems.map((fields, i) => (
        // TODO don't use index as key prop
        // https://robinpokorny.com/blog/index-as-a-key-is-an-anti-pattern/
        React.createElement(React.Fragment, { key: `item-${i}` },
            React.createElement(OnboardingFieldSetComponent, { fields: fields.filter(f => !f.absolutePath.endsWith('person_role')), getValueForField: group.getValueForField, setValueOfField: group.setValueOfField, onBlurField: onBlurOfField, onDelete: stakeholderItems.length > min ? () => onDeleteItem(i) : undefined, t: t, hasCardLayout: !(min === 1 && max === 1), highlightMandatoryButEmptyFields: false }),
            React.createElement(SpacerVertical, { small: true })))),
        stakeholderItems.length < max && (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    flex: 0,
                    display: 'flex',
                    justifyContent: 'flex-start',
                } },
                React.createElement(ButtonQuaternary, { size: "small", onClick: onAddItem }, t(`${tPrefix}.add_aditional_item`))),
            React.createElement(SpacerVertical, { small: true })))));
    const allMandatoryFilled = group.allMandatoryFilled(canSkipRole ? 0 : min);
    return (React.createElement(React.Fragment, null,
        canSkipRole ? (React.createElement(ToggleWrappedContent, { error: false, isDisabled: false, toggleOnChange: onToggle, toggleValue: yesNo, yesContent: React.createElement(Content, null) })) : (React.createElement(Content, null)),
        React.createElement(HorizontalWrapper, { display: "inline-flex", alignItems: "center", justifyContent: "flex-end" },
            canGoBack && (React.createElement(React.Fragment, null,
                React.createElement(SecondaryButton, { onClick: onBack }, t(`${tPrefix}.back`)),
                React.createElement(SpacerHorizontal, { medium: true }))),
            React.createElement(CallToActionButton, { disabled: !allMandatoryFilled || yesNo === undefined, onClick: onNext, loading: isLoading }, t(`${tPrefix}.continue`)))));
};
